import React from "react";
import styles from "./style.module.css";
import List from "../ListSection";

const Section = ({color , myList , text}) => {
  return (
    <div style={{backgroundColor: color}} className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <h4>{text}</h4>
        <svg
          width="38"
          height="63"
          viewBox="0 0 38 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2322 61.7678C18.2085 62.7441 19.7915 62.7441 20.7678 61.7678L36.6777 45.8579C37.654 44.8816 37.654 43.2986 36.6777 42.3223C35.7014 41.346 34.1184 41.346 33.1421 42.3223L19 56.4645L4.85786 42.3223C3.88155 41.346 2.29864 41.346 1.32233 42.3223C0.346017 43.2986 0.346017 44.8816 1.32233 45.8579L17.2322 61.7678ZM16.5 -1.47526e-07L16.5 60L21.5 60L21.5 1.47526e-07L16.5 -1.47526e-07Z"
            fill="white"
          />
        </svg>
        <div className={styles.allList} >
        {myList.map((item,index) => (
            <List key={index} item={item} />
        ))}
        </div>
      </div>
    </div>
  );
};

export default Section;
